/*
Select the tab by an id (eg 'about_us')
You can also select an element within a tab and it will open the tab then
navigate to the element.
Returns true if the tab changed, false otherwise.
*/
export function selectTabById(id) {
  // don't bother if there is no id or nothing that matches the id
  if (!id || !$(`section[data-tab-panel-id=${id}]`).length) return false;

  const $tabLink = $(`section[data-role=tab-set] nav a[href="#${id}"]`);

  // don't bother if the tab link is already active
  if ($tabLink.hasClass('active')) return false;

  const $tabSet = $tabLink.parents('section[data-role=tab-set]');
  const $tabLinks = $tabSet.find('nav ul li a');
  const $tabs = $tabSet.find('section[data-role=tab-panel]');
  const targetTabId = $tabLink.attr('href').replace('#', '');
  const $targetTab = $tabSet.find(`section[data-tab-panel-id=${targetTabId}]`);

  $tabLinks.removeClass('active');
  $tabLink.addClass('active');
  $tabs.removeClass('active');
  $targetTab.addClass('active');

  return true;
}

/*
Select the tab by hash (eg '#about_us')
Returns true if the tab changed, false otherwise
*/
export function selectTabByHash(hash) {
  return selectTabById(hash.replace('#', ''));
}

export function convertTabPanelIdToDataAttribute($panel) {
  $panel.attr('data-tab-panel-id', $panel.attr('id'));
  $panel.removeAttr('id');
}
